import React from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import Box from "../Box";
import { FlexBoxProps } from "./FlexBox.types";

const FlexBox = React.forwardRef<HTMLElement, FlexBoxProps>(
	({ className, basis, direction, grow, shrink, wrap, ...props }, ref) => {
		const block = new BemIt("FlexBox");

		return (
			<Box
				ref={ref}
				className={addClass(className).after(block)}
				display="flex"
				flexBasis={basis}
				flexDirection={direction}
				flexGrow={grow}
				flexShrink={shrink}
				flexWrap={wrap}
				{...props}
			/>
		);
	}
);

export default FlexBox;
